export default __webpack_public_path__ + "navigation-examples-custom-segue-thumbnail-960-f046c78ba92c1ec6b5e84dafbcde2883.webp";